import { lazy, Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RootState } from 'store';
import { MENU } from 'utils/constants';

import 'styles/index.scss';

const Home = lazy(() => import('./pages/Home'));
const Brand = lazy(() => import('./pages/Brands'));
const Partner = lazy(() => import('./pages/Partners'));
const About = lazy(() => import('./pages/About'));
const DeleteAccount = lazy(() => import('./pages/DeleteAccount'));
const Privacy = lazy(() => import('./pages/Privacy'));
const ContractPrinciples = lazy(() => import('./pages/ContractPrinciples'));
const PurchaseContract = lazy(() => import('./pages/PurchaseContract'));
const DeferredPurchaseOrder = lazy(
  () => import('./pages/DeferredPurchaseOrder')
);
const CaseStudy = lazy(() => import('./pages/CaseStudy'));

const App = () => {
  const { i18n } = useTranslation();
  const lang = useSelector((state: RootState) => state.i18.lang);

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path={MENU[0].path} element={<Home />} />
          <Route path={MENU[1].path} element={<Brand />} />
          <Route path={MENU[2].path} element={<Partner />} />
          <Route path={MENU[4].path} element={<About />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contract-principles" element={<ContractPrinciples />} />
          <Route path="/purchase-contract" element={<PurchaseContract />} />
          <Route
            path="/deferred-purchase-order"
            element={<DeferredPurchaseOrder />}
          />
          <Route path="/case-study/:id" element={<CaseStudy />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
